module.exports = __webpack_public_path__ + "static/media/fye-foot-left.b00f085a.png";